<script>
export default {
  render(h) {
    return h('div', 'Helaas, deze pagina bestaat niet (meer).')
  }
}
</script>
